<ion-accordion value="{{ listFacet?.displayName }}">
  <ion-item slot="header" class="facet-header" lines="none">
    {{ listFacet?.displayName }}
  </ion-item>
  <div slot="content" class="facet-value-list">
    <div class="facet-value-container">
      <ion-item
        class="facet-selection-container"
        *ngFor="
          let value of listFacet?.values | keyvalue;
          let i = index;
          trackBy: trackFacetValueId
        "
        [class.first]="i === 0"
      >
        <ion-checkbox
          labelPlacement="start"
          justify="space-between"
          class="facet-selection"
          mode="ios"
          [checked]="value?.value?.isSelected"
          (ionChange)="handleListFacetCheckboxSelection(value?.value)"
        >
          <span class="facet-value-text">
            {{
              value?.value?.value | acronymTitleCase | truncateWithEllipsis: 40
            }}
          </span>
        </ion-checkbox>
      </ion-item>
    </div>
  </div>
</ion-accordion>
